import { type FlowGetSftpFileBlockConfig, FlowGetSftpFileBlockConfigSchema } from 'flow-schema';

import { GetSftpFileFormFields } from './FormFields';
import { GetSftpFileDocumentation } from './documentation';
import { type BlockConfigProps } from '../../types';

export const getSftpFileConfig: BlockConfigProps<FlowGetSftpFileBlockConfig> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'getSftpFile',
  defaultConfig: {
    path: '',
    server: '',
  },
  configFields: {
    schema: FlowGetSftpFileBlockConfigSchema,
    FormFields: GetSftpFileFormFields,
  },
  documentationMarkdown: GetSftpFileDocumentation,
};
